import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import api from '../services/api';

export interface TenantBranding {
  primary?:    string;
  primaryDark?: string;
  onPrimary?:  string;
  logoUrl?:    string;
}

export interface TenantInfo {
  slug?:     string;
  name?:     string;
  authMode?: string;
  branding?: TenantBranding | null;
}

const TenantCtx = createContext<TenantInfo>({});

export function useTenant() {
  return useContext(TenantCtx);
}

/** Loads tenant branding (public endpoint) and injects --brand-* CSS variables. */
export function TenantProvider({ children }: { children: ReactNode }) {
  const [tenant, setTenant] = useState<TenantInfo>({});

  useEffect(() => {
    let cancelled = false;
    api.get('/tenant/branding')
      .then(res => {
        if (cancelled) return;
        const info: TenantInfo = res.data;
        setTenant(info);
        const b = info.branding;
        if (b) {
          const root = document.documentElement;
          if (b.primary)     root.style.setProperty('--brand-primary', b.primary);
          if (b.primaryDark) root.style.setProperty('--brand-primary-dark', b.primaryDark);
          if (b.onPrimary)   root.style.setProperty('--brand-on-primary', b.onPrimary);
        }
        if (info.name) document.title = info.name;
      })
      .catch(() => { /* no tenant branding (e.g. local dev) — keep defaults */ });
    return () => { cancelled = true; };
  }, []);

  return <TenantCtx.Provider value={tenant}>{children}</TenantCtx.Provider>;
}
